import { render, staticRenderFns } from "./SrConstructionCreate.vue?vue&type=template&id=06c97879&"
import script from "./SrConstructionCreate.vue?vue&type=script&lang=js&"
export * from "./SrConstructionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports